<script setup>
import { computed } from 'vue'
import { useUiStore } from '@/stores/ui'

const uiStore = useUiStore()

const toast = computed(() => uiStore.toast)

const typeIcon = computed(() => {
  switch (toast.value?.type) {
    case 'success': return '✓'
    case 'error': return '✕'
    case 'warning': return '⚠'
    default: return 'ℹ'
  }
})
</script>

<template>
  <Teleport to="body">
    <Transition name="toast">
      <div v-if="toast" :class="['toast', `toast-${toast.type}`]">
        <span class="toast-icon">{{ typeIcon }}</span>
        <span class="toast-message">{{ toast.message }}</span>
        <button class="toast-close" @click="uiStore.hideToast">✕</button>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
.toast {
  position: fixed;
  top: 80px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  box-shadow: 0 8px 24px var(--color-shadow);
  z-index: 2000;
  max-width: 400px;
}

.toast-success {
  border-left: 4px solid var(--color-success);
}

.toast-error {
  border-left: 4px solid var(--color-danger);
}

.toast-warning {
  border-left: 4px solid var(--color-warning);
}

.toast-info {
  border-left: 4px solid var(--color-info);
}

.toast-icon {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-weight: 700;
}

.toast-success .toast-icon {
  background: var(--color-success-light);
  color: var(--color-success);
}

.toast-error .toast-icon {
  background: var(--color-danger-light);
  color: var(--color-danger);
}

.toast-warning .toast-icon {
  background: var(--color-warning-light);
  color: var(--color-warning);
}

.toast-info .toast-icon {
  background: var(--color-info-light);
  color: var(--color-info);
}

.toast-message {
  flex: 1;
  color: var(--color-text);
  font-size: 0.95rem;
}

.toast-close {
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  border-radius: 4px;
}

.toast-close:hover {
  background: var(--color-background-secondary);
}

/* Transition */
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateX(100px);
}

@media (max-width: 480px) {
  .toast {
    left: 20px;
    right: 20px;
    max-width: none;
  }
}
</style>
